import React, { Button, Dialog, DialogActions, DialogTitle } from '@mui/material';
import { BonusCalculationService } from 'services';
import { CloseDayDialogProps } from './CloseDayDialogProps';

export const CloseDayDialog = ({ open, closeDialog }: CloseDayDialogProps) => {
	const handleCloseDay = async () => {
		await BonusCalculationService.processDailyBonusChanges();
		closeDialog();
	};
	return (
		<Dialog open={open} onClose={() => closeDialog()} fullWidth>
			<DialogTitle variant='h5'>Close day</DialogTitle>
			<DialogActions>
				<Button variant='contained' color='error' onClick={() => closeDialog()}>
					Cancel
				</Button>
				<Button variant='contained' color='primary' onClick={handleCloseDay}>
					Close Day
				</Button>
			</DialogActions>
		</Dialog>
	);
};
